type AccordionProps = {
  open: boolean;
  children: React.ReactNode;
};

export function SlideAccordion({ open, children }: AccordionProps) {
  return (
    <div
      className={`
        overflow-hidden
        transition-all duration-300 ease-out
        ${open ? "max-h-[1000px] opacity-100 translate-y-0" : "max-h-0 opacity-0 -translate-y-1"}
      `}
    >
      <div className="pt-3">
        {children}
      </div>
    </div>
  );
}